import { Pipe, PipeTransform } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/core/auth/services/auth.service';

@Pipe({
  name: 'secureImage'
})
export class SecureImagePipe implements PipeTransform {
  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private sanitizer: DomSanitizer
  ) {}

  transform(relativePath: string): Observable<SafeUrl> {
    if (!relativePath || !relativePath.startsWith('/')) {
      return of('assets/images/profile_placeholder.jpg');
    }

    const url = `${environment.api_url.replace('/v1', '')}${relativePath}`;

    return this.http
      .get(url, {
        responseType: 'blob',
        headers: { Authorization: `Bearer ${this.authService.getToken()}` }
      })
      .pipe(
      map(blob => {
        if (!blob || blob.size === 0) {
          return 'assets/images/profile_placeholder.jpg';
        }
        return this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob));
      }),
      catchError(() => of('assets/images/profile_placeholder.jpg'))
    );
  }
}